export const sizeNumeric = {
  xSmall: 24,
  small: 32,
  xMedium: 40,
  medium: 48,
  large: 56,
} as const

export const size = {
  xSmall: `${sizeNumeric.xSmall}px`,
  small: `${sizeNumeric.small}px`,
  xMedium: `${sizeNumeric.xMedium}px`,
  medium: `${sizeNumeric.medium}px`,
  large: `${sizeNumeric.large}px`,
} as const

export type Size = keyof typeof size
